/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Checkbox, CheckboxProps as MuiCheckboxProps, FormControlLabel } from "@mui/material";
import MDBox from "dashboard-template/components/MDBox";
import { forwardRef } from "react";
import Typography from "components/generals/Typography";

/**
 * Extended checkbox props with label and validation states.
 */
export interface CheckboxProps extends MuiCheckboxProps {
  label: string;
  error?: boolean;
  success?: boolean;
}

/**
 * Custom checkbox component with label and form integration.
 * 
 * Features:
 * - Integrated label with FormControlLabel
 * - Error and success state support
 * - Consistent styling with Material Dashboard theme
 * - Proper alignment and spacing
 * 
 * @param label - Text label displayed next to checkbox
 * @param rest - Standard Material-UI checkbox properties
 * @returns Checkbox with label component
 */
const MuiCheckbox = forwardRef(({ label, ...rest }: CheckboxProps, ref) => {
  return (
    <MDBox mb={0.75}>
      <FormControlLabel className="checkbox-label-center" control={<Checkbox {...rest} />} ref={ref} label={<Typography className="checkbox-label-size" title={label}>{label}</Typography>} />
    </MDBox>
  );
});     
export default MuiCheckbox;
